import React from 'react';
//import Scss
import "assets/scss/themes.scss";
// import 'devextreme/dist/css/dx.light.css';
import './assets/scss/theme/dx.fluent.devExtremeCustom.css';
import 'font-awesome/css/font-awesome.min.css';

//imoprt Route
import Route from 'Routes/Index';
import { ToastContainer } from 'react-toastify';

const App = () => {

  return (
    <React.Fragment>
      <Route />
      <ToastContainer />
    </React.Fragment>
  );
}

export default App;